<div class="property-agent-contact-details-section">
    <tg-col>
        <div
            *ngIf="draftLoaded$ | async"
            class="
                    property-ui__grid-content property-ui__grid-content--ruled
                    property-agent-contact-details-section--large-margin
                ">
            <property-agent-contact-detail
                [contactDetailType]="propertyAgentContactDetailsType.primary"
                [phoneValidation]="phoneValidations[propertyAgentContactDetailsType.primary]"
                [hasErrorInContactDetails]="hasErrorInContactDetails"
                (contactDetailsChange)="onContactDetailsChange($event)"
                [draftData]="draftData"
                [validation]="validation"
                (deleteContactDetails)="onRemoveSecondContact()">
            </property-agent-contact-detail>
        </div>
    </tg-col>
    <tg-col *ngIf="!isSecondContactDetailAdded">
        <button
            type="button"
            class="
                    btn-add-second-contact
                    property-agent-contact-details-section--large-margin
                    property-agent-contact-details-section--no-padding-bottom
                "
            (click)="onAddSecondContact()">
            <ng-container>
                <tg-icon name="profile-agent" role="presentation" size="small"></tg-icon>
                <span>Add second contact</span>
            </ng-container>
        </button>
    </tg-col>
    <tg-col *ngIf="isSecondContactDetailAdded">
        <div
            *ngIf="draftLoaded$ | async"
            class="
                    property-ui__grid-content
                    property-agent-contact-details-section--large-margin
                    property-agent-contact-details-section--no-padding-bottom
                ">
            <property-agent-contact-detail
                [contactDetailType]="propertyAgentContactDetailsType.secondary"
                [phoneValidation]="phoneValidations[propertyAgentContactDetailsType.secondary]"
                [hasErrorInContactDetails]="hasErrorInSecondContactDetails"
                (contactDetailsChange)="onContactDetailsChange($event)"
                [draftData]="draftData"
                [validation]="validation"
                (deleteContactDetails)="onRemoveSecondContact()">
            </property-agent-contact-detail>
        </div>
    </tg-col>
</div>
